// // import React, { useState, useEffect } from 'react';
// // import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Badge } from 'react-bootstrap';
// // import './OPAC.css';

// // const OPAC = () => {
// //   const [step, setStep] = useState(1);
// //   const [card_number, setcard_number] = useState('');
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');
// //   const [success, setSuccess] = useState('');
// //   const [member, setMember] = useState(null);
// //   const [books, setBooks] = useState([]);
// //   const [categories, setCategories] = useState([]);
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const [selectedCategory, setSelectedCategory] = useState('');
// //   const [page, setPage] = useState(1);
// //   const [totalPages, setTotalPages] = useState(1);
// //   const [myRequests, setMyRequests] = useState([]);
// //   const [showRequests, setShowRequests] = useState(false);
// //   const [showBookCopies, setShowBookCopies] = useState(false);
// //   const [selectedBook, setSelectedBook] = useState(null);
// //   const [bookCopies, setBookCopies] = useState([]);
// //   const [copiesPage, setCopiesPage] = useState(1);
// //   const [copiesTotalPages, setCopiesTotalPages] = useState(1);
// //   const [totalCopies, setTotalCopies] = useState(0);

// //   useEffect(() => {
// //     if (step === 2 && member) {
// //       loadCategories();
// //       loadBooks();
// //     }
// //   }, [step, member]);

// //   const handleVerifyMember = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);
// //     setError('');

// //     try {
// //       // Backend URL: http://localhost:3003/ibs/api/opac/verify-member
// //       const response = await fetch('http://localhost:3003/api/opac/verify-member', {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json'
// //         },
// //         body: JSON.stringify({ card_number })
// //       });

// //       const data = await response.json();

// //       if (data.success) {
// //         setMember(data.member);
// //         setSuccess('Member verified successfully!');
// //         setTimeout(() => {
// //           setSuccess('');
// //           setStep(2);
// //         }, 1000);
// //       } else {
// //         setError(data.message || 'Member verification failed');
// //       }
// //     } catch (err) {
// //       console.error('Error:', err);
// //       setError('Failed to verify member. Please try again.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };
// //   const loadCategories = async () => {
// //     try {
// //       const response = await fetch('http://localhost:3003/api/opac/categories');

// //       const data = await response.json();
// //       if (data.success) {
// //         setCategories(data.data);
// //       }
// //     } catch (err) {
// //       console.error('Failed to load categories:', err);
// //     }
// //   };

// //   const loadBooks = async (pageNum = 1) => {
// //     try {
// //       setLoading(true);
// //       const params = new URLSearchParams({
// //         page: pageNum,
// //         limit: 12
// //       });

// //       if (searchTerm) params.append('search', searchTerm);
// //       if (selectedCategory) params.append('category', selectedCategory);
// //       if (member?.branchId) params.append('branchId', member.branchId);

// //       const response = await fetch(`http://localhost:3003/api/opac/books?${params}`);

// //       const data = await response.json();
// //       if (data.success) {
// //         setBooks(data.data);
// //         setTotalPages(data.pagination.totalPages);
// //         setPage(pageNum);
// //       }
// //     } catch (err) {
// //       setError('Failed to load books');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleSearch = (e) => {
// //     e.preventDefault();
// //     loadBooks(1);
// //   };

// //   const handleRequestBook = async (book) => {
// //     if (!member) {
// //       setError('Please verify your membership first');
// //       setTimeout(() => setError(''), 3000);
// //       return;
// //     }

// //     // Set selected book and show copies modal
// //     setSelectedBook(book);
// //     setShowBookCopies(true);
// //     setCopiesPage(1); // Reset to page 1
// //     loadBookCopies(book.id);
// //   };

// //   const loadBookCopies = async (bookId, pageNum = 1) => {
// //     try {
// //       setLoading(true);
// //       const response = await fetch(`http://localhost:3003/api/opac/book-copies?bookId=${bookId}&page=${pageNum}&limit=10`);

// //       const data = await response.json();
// //       if (data.success) {
// //         setBookCopies(data.data);
// //         setCopiesTotalPages(data.pagination.totalPages);
// //         setTotalCopies(data.pagination.totalItems);
// //         setCopiesPage(pageNum);
// //       } else {
// //         setError('Failed to load book copies');
// //       }
// //     } catch (err) {
// //       setError('Failed to load book copies');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleCopiesPageChange = (newPage) => {
// //     loadBookCopies(selectedBook.id, newPage);
// //   };

// //   const requestSpecificCopy = async (copyId) => {
// //     if (!member || !selectedBook) {
// //       setError('Please verify your membership first');
// //       setTimeout(() => setError(''), 3000);
// //       return;
// //     }

// //     try {
// //       const response = await fetch('http://localhost:3003/api/opac/request-copy', {
// //         method: 'POST',
// //         headers: {
// //           'Content-Type': 'application/json'
// //         },
// //         body: JSON.stringify({
// //           copyId: copyId,
// //           bookId: selectedBook.id,
// //           memberId: member.id
// //         })
// //       });

// //       const data = await response.json();
// //       if (data.success) {
// //         setSuccess('Book copy requested successfully!');
// //         setTimeout(() => setSuccess(''), 3000);
// //         setShowBookCopies(false);
// //         // Refresh books to update available copies count
// //         loadBooks(page);
// //         // Refresh requests if shown
// //         if (showRequests) {
// //           loadMyRequests();
// //         }
// //       } else {
// //         setError(data.message);
// //         setTimeout(() => setError(''), 3000);
// //       }
// //     } catch (err) {
// //       setError('Failed to request book copy');
// //       setTimeout(() => setError(''), 3000);
// //     }
// //   };

// //   const loadMyRequests = async () => {
// //     if (!member) {
// //       setError('Please verify your membership first');
// //       setTimeout(() => setError(''), 3000);
// //       return;
// //     }

// //     try {
// //       const response = await fetch('http://localhost:3003/api/opac/my-requests');

// //       const data = await response.json();
// //       if (data.success) {
// //         setMyRequests(data.data);
// //       } else {
// //         setError('Failed to load requests');
// //       }
// //     } catch (err) {
// //       setError('Failed to load requests');
// //     }
// //   };

// //   // Load requests when showing the requests panel
// //   useEffect(() => {
// //     if (showRequests && member) {
// //       loadMyRequests();
// //     }
// //   }, [showRequests, member]);

// //   const handleLogout = () => {
// //     setStep(1);
// //     setMember(null);
// //     setcard_number('');
// //     setMyRequests([]);
// //     setShowRequests(false);
// //     setShowBookCopies(false);
// //     setBooks([]);
// //     setCategories([]);
// //     setSearchTerm('');
// //     setSelectedCategory('');
// //     setPage(1);
// //     setTotalPages(1);
// //   };

// //   const getStatusBadge = (status) => {
// //     const statusConfig = {
// //       'PENDING': { variant: 'warning', text: 'Pending' },
// //       'APPROVED': { variant: 'success', text: 'Approved' },
// //       'REJECTED': { variant: 'danger', text: 'Rejected' },
// //       'ISSUED': { variant: 'primary', text: 'Issued' },
// //       'RETURNED': { variant: 'secondary', text: 'Returned' }
// //     };

// //     const config = statusConfig[status] || { variant: 'secondary', text: status };
// //     return <Badge bg={config.variant}>{config.text}</Badge>;
// //   };

// //   if (step === 1) {
// //     return (
// //       <div className="opac-container">
// //         <Container className="py-5">
// //           <Row className="justify-content-center">
// //             <Col md={8} lg={6}>
// //               <Card className="opac-card shadow-lg">
// //                 <Card.Header className="text-center bg-primary text-white py-4">
// //                   <div className="opac-icon mb-2">📚</div>
// //                   <h2 className="mb-0">Library OPAC</h2>
// //                   <p className="mb-0">Online Public Access Catalog</p>
// //                 </Card.Header>
// //                 <Card.Body className="p-4">
// //                   {error && <Alert variant="danger">{error}</Alert>}
// //                   {success && <Alert variant="success">{success}</Alert>}

// //                   <Form onSubmit={handleVerifyMember}>
// //                     <Form.Group className="mb-4">
// //                       <Form.Label className="fw-bold">
// //                         <span className="me-2">👤</span>
// //                         Library Membership ID
// //                       </Form.Label>
// //                       <Form.Control
// //                         type="text"
// //                         placeholder="Enter your membership ID"
// //                         value={card_number}
// //                         onChange={(e) => setcard_number(e.target.value)}
// //                         required
// //                         size="lg"
// //                         className="text-center"
// //                       />
// //                     </Form.Group>

// //                     <div className="d-grid">
// //                       <Button
// //                         type="submit"
// //                         variant="primary"
// //                         size="lg"
// //                         disabled={loading}
// //                       >
// //                         {loading ? (
// //                           <>
// //                             <Spinner
// //                               as="span"
// //                               animation="border"
// //                               size="sm"
// //                               className="me-2"
// //                             />
// //                             Verifying...
// //                           </>
// //                         ) : (
// //                           'Verify & Access Catalog'
// //                         )}
// //                       </Button>
// //                     </div>
// //                   </Form>

// //                   <div className="text-center mt-4">
// //                     <small className="text-muted">
// //                       <span className="me-1">⏰</span>
// //                       Session expires after 15 minutes of inactivity
// //                     </small>
// //                   </div>
// //                 </Card.Body>
// //               </Card>
// //             </Col>
// //           </Row>
// //         </Container>
// //       </div>
// //     );
// //   }

// //   if (step === 2) {
// //     return (
// //       <div className="opac-container">
// //         {/* Header */}
// //         <div className="opac-header bg-white shadow-sm">
// //           <Container>
// //             <div className="d-flex justify-content-between align-items-center">
// //               <div className="d-flex align-items-center">
// //                 <span className="opac-header-icon text-primary">📚</span>
// //                 <div>
// //                   <h3>Library Catalog</h3>
// //                   {member && (
// //                     <div className="member-profile">
// //                       <div className="member-info">
// //                         <span className="member-name">{member.firstName} {member.lastName}</span>
// //                         <span className="member-details">
// //                           Plan: {member.planName} |
// //                           Branch: {member.branchName} |
// //                           ID: {member.membership_id}
// //                         </span>
// //                       </div>
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>

// //               <div className="d-flex align-items-center gap-3">
// //                 <Button
// //                   variant="outline-primary"
// //                   onClick={() => setShowRequests(!showRequests)}
// //                 >
// //                   My Requests {myRequests.length > 0 && `(${myRequests.length})`}
// //                 </Button>
// //                 <Button
// //                   variant="outline-secondary"
// //                   className="btn-logout"
// //                   onClick={() => {
// //                     setStep(1);
// //                     setMember(null);
// //                     setcard_number('');
// //                     setMyRequests([]);
// //                     setShowRequests(false);
// //                     setShowBookCopies(false);
// //                     setBooks([]);
// //                     setCategories([]);
// //                     setSearchTerm('');
// //                     setSelectedCategory('');
// //                     setPage(1);
// //                     setTotalPages(1);
// //                   }}
// //                 >
// //                   🚪 Logout
// //                 </Button>
// //               </div>
// //             </div>
// //           </Container>
// //         </div>

// //         <Container className="py-4">
// //           {error && <Alert variant="danger" onClose={() => setError()} dismissible>{error}</Alert>}
// //           {success && <Alert variant="success" onClose={() => setSuccess()} dismissible>{success}</Alert>
// //           }

// //           {/* Search and Filters */}
// //           {/* <Card className="mb-4">
// //             <Card.Body>
// //               <Form onSubmit={handleSearch}>
// //                 <Row>
// //                   <Col md={6}>
// //                     <Form.Group>
// //                       <Form.Control
// //                         type="text"
// //                         placeholder="Search books by title, author, or ISBN..."
// //                         value={searchTerm}
// //                         onChange={(e) => setSearchTerm(e.target.value)}
// //                       />
// //                     </Form.Group>
// //                   </Col>
// //                   <Col md={4}>
// //                     <Form.Select
// //                       value={selectedCategory}
// //                       onChange={(e) => setSelectedCategory(e.target.value)}
// //                     >
// //                       <option value="">All Categories</option>
// //                       {categories.map(cat => (
// //                         <option key={cat.id} value={cat.id}>
// //                           {cat.name} ({cat.book_count})
// //                         </option>
// //                       ))}
// //                     </Form.Select>
// //                   </Col>
// //                   <Col md={2}>
// //                     <Button type="submit" variant="primary" className="w-100">
// //                       <span className="me-1">🔍</span> Search
// //                     </Button>
// //                   </Col>
// //                 </Row>
// //               </Form>
// //             </Card.Body>
// //           </Card> */}

// //           {/* My Requests Modal */}
// //           {showRequests && (
// //             <Card className="mb-4">
// //               <Card.Header>
// //                 <h5 className="mb-0">My Book Requests</h5>
// //               </Card.Header>
// //               <Card.Body>
// //                 {myRequests.length === 0 ? (
// //                   <p className="text-center text-muted">No requests found</p>
// //                 ) : (
// //                   <div className="requests-list">
// //                     {myRequests.map(request => (
// //                       <div key={request.id} className="request-item p-3 border-bottom">
// //                         <div className="d-flex justify-content-between align-items-center">
// //                           <div>
// //                             <h6 className="mb-1">{request.title}</h6>
// //                             <small className="text-muted">by {request.author_name}</small>
// //                           </div>
// //                           <div className="text-end">
// //                             {getStatusBadge(request.status)}
// //                             <div className="mt-1">
// //                               <small className="text-muted">
// //                                 Requested: {new Date(request.requested_date).toLocaleDateString()}
// //                               </small>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}
// //                 <div className="text-center mt-3">
// //                   <Button variant="outline-secondary" onClick={() => setShowRequests(false)}>
// //                     Close
// //                   </Button>
// //                 </div>
// //               </Card.Body>
// //             </Card>
// //           )}


// //           <>
// //             <div className="d-flex justify-content-between align-items-center mb-3">
// //               <h4>Available Books</h4>
// //               <div className="text-white">
// //                 Showing {books.length} books
// //               </div>
// //             </div>

// //             <Row>
// //               {books.map(book => (
// //                 <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
// //                   <Card className="h-100 book-card">
// //                     <div className="book-cover-placeholder">
// //                       {book.image_url ? (
// //                         <Card.Img
// //                           variant="top"
// //                           src={book.image_url}
// //                           alt={book.title}
// //                           className="book-cover"
// //                         />
// //                       ) : (
// //                         <div className="book-cover-placeholder-content">
// //                           <div className="book-icon">📚</div>
// //                           <div className="mt-2">No Cover</div>
// //                         </div>
// //                       )}
// //                     </div>
// //                     <Card.Body className="d-flex flex-column">
// //                       <Card.Title className="book-title mb-2">
// //                         {book.title}
// //                       </Card.Title>
// //                       <Card.Text className="text-muted small mb-2">
// //                         by {book.author_name || 'Unknown Author'}
// //                       </Card.Text>
// //                       <div className="mt-auto">
// //                         <div className="d-flex justify-content-between align-items-center mb-2">
// //                           <Badge bg="info">{book.category_name}</Badge>
// //                           <div className="text-success">
// //                             <span className="me-1">✓</span>
// //                             {book.available_copies} available
// //                           </div>
// //                         </div>
// //                         <Button
// //                           variant="primary"
// //                           className="w-100"
// //                           onClick={() => handleRequestBook(book)}
// //                         >
// //                           Request Book
// //                         </Button>
// //                       </div>
// //                     </Card.Body>
// //                   </Card>
// //                 </Col>
// //               ))}
// //             </Row>

// //             {showBookCopies && selectedBook && (
// //               <Card className="mb-4 shadow-sm">
// //                 <Card.Header className="d-flex justify-content-between align-items-center text-dark " style={{ background: "var(--primary-color)" }}
// //                 >
// //                   <h5 className="mb-0">{selectedBook.title}</h5>
// //                   <small className="text-dark-50">
// //                     Total Copies: {totalCopies} | Available: {bookCopies.filter(c => c.status === 'AVAILABLE').length}
// //                   </small>
// //                   <Button variant="outline-light" onClick={() => setShowBookCopies(false)}>
// //                     ✕ Close
// //                   </Button>
// //                 </Card.Header>
// //                 <Card.Body>
// //                   {loading ? (
// //                     <div className="text-center">
// //                       <Spinner animation="border" variant="primary" />
// //                       <p className="text-muted">Loading book copies...</p>
// //                     </div>
// //                   ) : bookCopies.length === 0 ? (
// //                     <div className="text-center">
// //                       <div className="text-muted">📚</div>
// //                       <p className="text-muted">No copies available for this book</p>
// //                     </div>
// //                   ) : (
// //                     <>
// //                       {/* Table View for Book Copies */}
// //                       <div className="table-responsive">
// //                         <table className="table table-hover table-bordered align-middle">
// //                           <thead className="table-light">
// //                             <tr>
// //                               <th>#</th>
// //                               <th>Call Number</th>
// //                               <th>Location</th>
// //                               <th>Status</th>
// //                               <th className="text-center">Action</th>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {bookCopies.map((copy, index) => (
// //                               <tr key={copy.id}>
// //                                 <td style={{ width: '60px' }}>
// //                                   {(copiesPage - 1) * 10 + index + 1}
// //                                 </td>
// //                                 <td>
// //                                   {copy.itemcallnumber ? (
// //                                     <span className="fw-semibold">{copy.itemcallnumber}</span>
// //                                   ) : (
// //                                     <span className="text-muted fst-italic">Not assigned</span>
// //                                   )}
// //                                 </td>
// //                                 <td>
// //                                   {copy.rack_location ? (
// //                                     <span>📍 {copy.rack_location}</span>
// //                                   ) : (
// //                                     <span className="text-muted fst-italic">Not specified</span>
// //                                   )}
// //                                 </td>
// //                                 <td style={{ width: '120px' }}>
// //                                   <Badge
// //                                     bg={copy.status === 'AVAILABLE' ? 'success' : 'secondary'}
// //                                     className="px-3 py-2 w-100"
// //                                   >
// //                                     {copy.status}
// //                                   </Badge>
// //                                 </td>
// //                                 <td style={{ width: '120px' }} className="text-center">
// //                                   <Button
// //                                     variant={copy.status === 'AVAILABLE' ? 'primary' : 'outline-secondary'}
// //                                     size="sm"
// //                                     disabled={copy.status !== 'AVAILABLE'}
// //                                     onClick={() => requestSpecificCopy(copy.id)}
// //                                     className="px-3 w-100"
// //                                   >
// //                                     {copy.status === 'AVAILABLE' ? 'Request' : 'Not Available'}
// //                                   </Button>
// //                                 </td>
// //                               </tr>
// //                             ))}
// //                           </tbody>
// //                         </table>
// //                       </div>

// //                       {/* Pagination for Book Copies */}
// //                       {copiesTotalPages > 1 && (
// //                         <div className="d-flex justify-content-center mt-4">
// //                           <nav>
// //                             <ul className="pagination">
// //                               <li className={`page-item ${copiesPage === 1 ? 'disabled' : ''}`}>
// //                                 <button
// //                                   className="page-link"
// //                                   onClick={() => handleCopiesPageChange(copiesPage - 1)}
// //                                   disabled={copiesPage === 1}
// //                                 >
// //                                   Previous
// //                                 </button>
// //                               </li>

// //                               {[...Array(copiesTotalPages)].map((_, i) => (
// //                                 <li key={i + 1} className={`page-item ${copiesPage === i + 1 ? 'active' : ''}`}>
// //                                   <button
// //                                     className="page-link"
// //                                     onClick={() => handleCopiesPageChange(i + 1)}
// //                                   >
// //                                     {i + 1}
// //                                   </button>
// //                                 </li>
// //                               ))}

// //                               <li className={`page-item ${copiesPage === copiesTotalPages ? 'disabled' : ''}`}>
// //                                 <button
// //                                   className="page-link"
// //                                   onClick={() => handleCopiesPageChange(copiesPage + 1)}
// //                                   disabled={copiesPage === copiesTotalPages}
// //                                 >
// //                                   Next
// //                                 </button>
// //                               </li>
// //                             </ul>
// //                           </nav>
// //                         </div>
// //                       )}
// //                     </>
// //                   )}
// //                 </Card.Body>
// //               </Card>
// //             )}

// //             {/* Pagination for Books */}
// //             {totalPages > 1 && (
// //               <div className="d-flex justify-content-center mt-4">
// //                 <nav>
// //                   <ul className="pagination">
// //                     <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
// //                       <button
// //                         className="page-link"
// //                         onClick={() => loadBooks(page - 1)}
// //                         disabled={page === 1}
// //                       >
// //                         Previous
// //                       </button>
// //                     </li>

// //                     {[...Array(totalPages)].map((_, i) => (
// //                       <li key={i + 1} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
// //                         <button
// //                           className="page-link"
// //                           onClick={() => loadBooks(i + 1)}
// //                         >
// //                           {i + 1}
// //                         </button>
// //                       </li>
// //                     ))}

// //                     <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
// //                       <button
// //                         className="page-link"
// //                         onClick={() => loadBooks(page + 1)}
// //                         disabled={page === totalPages}
// //                       >
// //                         Next
// //                       </button>
// //                     </li>
// //                   </ul>
// //                 </nav>
// //               </div>
// //             )}
// //           </>

// //         </Container>
// //       </div>
// //     );
// //   }
// // };

// // export default OPAC;


// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Badge } from 'react-bootstrap';
// import './OPAC.css';

// const OPAC = () => {
//   const [card_number, setcard_number] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [member, setMember] = useState(null);
//   const [books, setBooks] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [myRequests, setMyRequests] = useState([]);
//   const [showRequests, setShowRequests] = useState(false);
//   const [showBookCopies, setShowBookCopies] = useState(false);
//   const [selectedBook, setSelectedBook] = useState(null);
//   const [bookCopies, setBookCopies] = useState([]);
//   const [copiesPage, setCopiesPage] = useState(1);
//   const [copiesTotalPages, setCopiesTotalPages] = useState(1);
//   const [totalCopies, setTotalCopies] = useState(0);

//   useEffect(() => {
//     if (member) {
//       loadCategories();
//       loadBooks();
//     }
//   }, [member]);

//   const handleVerifyMember = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/verify-member', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({ card_number })
//       });

//       const data = await response.json();

//       if (data.success) {
//         setMember(data.member);
//         setSuccess('Member verified successfully!');
//         setTimeout(() => setSuccess(''), 3000);
//       } else {
//         setError(data.message || 'Member verification failed');
//       }
//     } catch (err) {
//       console.error('Error:', err);
//       setError('Failed to verify member. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadCategories = async () => {
//     try {
//       const response = await fetch('http://localhost:3003/api/opac/categories');
//       const data = await response.json();
//       if (data.success) {
//         setCategories(data.data);
//       }
//     } catch (err) {
//       console.error('Failed to load categories:', err);
//     }
//   };

//   const loadBooks = async (pageNum = 1) => {
//     try {
//       setLoading(true);
//       const params = new URLSearchParams({
//         page: pageNum,
//         limit: 12
//       });

//       if (searchTerm) params.append('search', searchTerm);
//       if (selectedCategory) params.append('category', selectedCategory);
//       if (member?.branchId) params.append('branchId', member.branchId);

//       const response = await fetch(`http://localhost:3003/api/opac/books?${params}`);
//       const data = await response.json();

//       if (data.success) {
//         setBooks(data.data);
//         setTotalPages(data.pagination.totalPages);
//         setPage(pageNum);
//       }
//     } catch (err) {
//       setError('Failed to load books');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     loadBooks(1);
//   };

//   const handleRequestBook = async (book) => {
//     if (!member) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     setSelectedBook(book);
//     setShowBookCopies(true);
//     setCopiesPage(1);
//     loadBookCopies(book.id);
//   };

//   const loadBookCopies = async (bookId, pageNum = 1) => {
//     try {
//       setLoading(true);
//       const response = await fetch(`http://localhost:3003/api/opac/book-copies?bookId=${bookId}&page=${pageNum}&limit=10`);
//       const data = await response.json();

//       if (data.success) {
//         setBookCopies(data.data);
//         setCopiesTotalPages(data.pagination.totalPages);
//         setTotalCopies(data.pagination.totalItems);
//         setCopiesPage(pageNum);
//       } else {
//         setError('Failed to load book copies');
//       }
//     } catch (err) {
//       setError('Failed to load book copies');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCopiesPageChange = (newPage) => {
//     loadBookCopies(selectedBook.id, newPage);
//   };

//   const requestSpecificCopy = async (copyId) => {
//     if (!member || !selectedBook) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/request-copy', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           copyId: copyId,
//           bookId: selectedBook.id,
//           memberId: member.id
//         })
//       });

//       const data = await response.json();
//       if (data.success) {
//         setSuccess('Book copy requested successfully!');
//         setTimeout(() => setSuccess(''), 3000);
//         setShowBookCopies(false);
//         loadBooks(page);
//         if (showRequests) {
//           loadMyRequests();
//         }
//       } else {
//         setError(data.message);
//         setTimeout(() => setError(''), 3000);
//       }
//     } catch (err) {
//       setError('Failed to request book copy');
//       setTimeout(() => setError(''), 3000);
//     }
//   };

//   const loadMyRequests = async () => {
//     if (!member) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/my-requests');
//       const data = await response.json();
//       if (data.success) {
//         setMyRequests(data.data);
//       } else {
//         setError('Failed to load requests');
//       }
//     } catch (err) {
//       setError('Failed to load requests');
//     }
//   };

//   useEffect(() => {
//     if (showRequests && member) {
//       loadMyRequests();
//     }
//   }, [showRequests, member]);

//   const handleLogout = () => {
//     setMember(null);
//     setcard_number('');
//     setMyRequests([]);
//     setShowRequests(false);
//     setShowBookCopies(false);
//     setBooks([]);
//     setCategories([]);
//     setSearchTerm('');
//     setSelectedCategory('');
//     setPage(1);
//     setTotalPages(1);
//     setSuccess('Logged out successfully!');
//     setTimeout(() => setSuccess(''), 3000);
//   };

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       'PENDING': { variant: 'warning', text: 'Pending' },
//       'APPROVED': { variant: 'success', text: 'Approved' },
//       'REJECTED': { variant: 'danger', text: 'Rejected' },
//       'ISSUED': { variant: 'primary', text: 'Issued' },
//       'RETURNED': { variant: 'secondary', text: 'Returned' }
//     };

//     const config = statusConfig[status] || { variant: 'secondary', text: status };
//     return <Badge bg={config.variant}>{config.text}</Badge>;
//   };

//   return (
//     <div className="opac-container">
//       <Container>
//         <Row className="justify-content-center mb-4">
//           <Col md={8} lg={6}>
//             <Card className="opac-card shadow">
//               <Card.Header className="text-center bg-primary text-white py-3">
//                 <div className="opac-icon mb-2">📚</div>
//                 <h2 className="mb-0">Library OPAC</h2>
//                 <p className="mb-0">Online Public Access Catalog</p>
//               </Card.Header>
//               <Card.Body className="p-4">
//                 {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
//                 {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}

//                 {!member ? (
//                   <Form onSubmit={handleVerifyMember}>
//                     <Form.Group className="mb-4">
//                       <Form.Label className="fw-bold">
//                         <span className="me-2">👤</span>
//                         Library Membership ID
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         placeholder="Enter your membership ID"
//                         value={card_number}
//                         onChange={(e) => setcard_number(e.target.value)}
//                         required
//                         size="lg"
//                         className="text-center"
//                       />
//                     </Form.Group>

//                     <div className="d-grid">
//                       <Button
//                         type="submit"
//                         variant="primary"
//                         size="lg"
//                         disabled={loading}
//                       >
//                         {loading ? (
//                           <>
//                             <Spinner as="span" animation="border" size="sm" className="me-2" />
//                             Verifying...
//                           </>
//                         ) : (
//                           'Verify Membership'
//                         )}
//                       </Button>
//                     </div>
//                   </Form>
//                 ) : (
//                   <div className="member-info text-center">
//                     <div className="mb-3">
//                       <span className="display-6">👤</span>
//                       <h4 className="mt-2">{member.firstName} {member.lastName}</h4>
//                     </div>
//                     <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
//                       <Badge bg="info">Plan: {member.planName}</Badge>
//                       <Badge bg="secondary">Branch: {member.branchName}</Badge>
//                       <Badge bg="dark">ID: {member.membership_id}</Badge>
//                     </div>
//                     <Button variant="outline-danger" onClick={handleLogout} size="sm">
//                       🚪 Logout
//                     </Button>
//                   </div>
//                 )}
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>

//         {/* Main Content - Only show if member is verified */}
//         {member && (
//           <>
//             {/* Search and Filters */}
//             <Card className="mb-4 shadow-sm">
//               <Card.Body>
//                 <Form onSubmit={handleSearch}>
//                   <Row>
//                     <Col md={5}>
//                       <Form.Group>
//                         <Form.Control
//                           type="text"
//                           placeholder="Search books by title, author, or ISBN..."
//                           value={searchTerm}
//                           onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Select
//                         value={selectedCategory}
//                         onChange={(e) => setSelectedCategory(e.target.value)}
//                       >
//                         <option value="">All Categories</option>
//                         {categories.map(cat => (
//                           <option key={cat.id} value={cat.id}>
//                             {cat.name} ({cat.book_count})
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={2}>
//                       <Button type="submit" variant="primary" className="w-100">
//                         <span className="me-1">🔍</span> Search
//                       </Button>
//                     </Col>
//                     <Col md={1}>
//                       <Button
//                         variant="outline-primary"
//                         className="w-100"
//                         onClick={() => setShowRequests(!showRequests)}
//                         title="My Requests"
//                       >
//                         📋 {myRequests.length > 0 && `(${myRequests.length})`}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </Card.Body>
//             </Card>

//             {/* My Requests Modal */}
//             {showRequests && (
//               <Card className="mb-4 shadow">
//                 <Card.Header className="d-flex justify-content-between align-items-center">
//                   <h5 className="mb-0">My Book Requests</h5>
//                   <Button variant="outline-secondary" size="sm" onClick={() => setShowRequests(false)}>
//                     ✕
//                   </Button>
//                 </Card.Header>
//                 <Card.Body>
//                   {myRequests.length === 0 ? (
//                     <p className="text-center text-muted">No requests found</p>
//                   ) : (
//                     <div className="requests-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
//                       {myRequests.map(request => (
//                         <div key={request.id} className="request-item p-3 border-bottom">
//                           <div className="d-flex justify-content-between align-items-center">
//                             <div>
//                               <h6 className="mb-1">{request.title}</h6>
//                               <small className="text-muted">by {request.author_name}</small>
//                             </div>
//                             <div className="text-end">
//                               {getStatusBadge(request.status)}
//                               <div className="mt-1">
//                                 <small className="text-muted">
//                                   {new Date(request.requested_date).toLocaleDateString()}
//                                 </small>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             )}

//             {/* Books Grid */}
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h4>Available Books</h4>
//               <div className="text-muted">
//                 Showing {books.length} books
//               </div>
//             </div>

//             <Row>
//               {books.map(book => (
//                 <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
//                   <Card className="h-100 book-card shadow-sm">
//                     {/* <div className="book-cover-placeholder">
//                       {book.image_url ? (
//                         <Card.Img
//                           variant="top"
//                           src={book.image_url}
//                           alt={book.title}
//                           className="book-cover"
//                         />
//                       ) : (
//                         <div className="book-cover-placeholder-content">
//                           <div className="book-icon">📚</div>
//                           <div className="mt-2">No Cover</div>
//                         </div>
//                       )}
//                     </div> */}
//                     <Card.Body className="d-flex flex-column">
//                       <Card.Title className="book-title mb-2">
//                         {book.title}
//                       </Card.Title>
//                       <Card.Text className="text-muted small mb-2">
//                         by {book.author_name || 'Unknown Author'}
//                       </Card.Text>
//                       <div className="mt-auto">
//                         <div className="d-flex justify-content-between align-items-center mb-2">
//                           <Badge bg="info">{book.category_name}</Badge>
//                           <div className="text-success">
//                             <span className="me-1">✓</span>
//                             {book.available_copies} available
//                           </div>
//                         </div>
//                         <Button
//                           variant="primary"
//                           className="w-100"
//                           onClick={() => handleRequestBook(book)}
//                           disabled={book.available_copies === 0}
//                         >
//                           {book.available_copies > 0 ? 'Request Book' : 'Not Available'}
//                         </Button>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               ))}
//             </Row>

//             {/* Book Copies Modal */}
//             {showBookCopies && selectedBook && (
//               <Card className="mb-4 shadow-lg">
//                 <Card.Header className="d-flex justify-content-between align-items-center bg-primary text-white">
//                   <h5 className="mb-0">{selectedBook.title}</h5>
//                   <div>
//                     <small className="me-3">
//                       Total: {totalCopies} | Available: {bookCopies.filter(c => c.status === 'AVAILABLE').length}
//                     </small>
//                     <Button variant="outline-light" size="sm" onClick={() => setShowBookCopies(false)}>
//                       ✕ Close
//                     </Button>
//                   </div>
//                 </Card.Header>
//                 <Card.Body>
//                   {loading ? (
//                     <div className="text-center py-4">
//                       <Spinner animation="border" variant="primary" />
//                       <p className="text-muted mt-2">Loading book copies...</p>
//                     </div>
//                   ) : bookCopies.length === 0 ? (
//                     <div className="text-center py-4">
//                       <div className="display-1 text-muted">📚</div>
//                       <p className="text-muted">No copies available for this book</p>
//                     </div>
//                   ) : (
//                     <>
//                       <div className="table-responsive">
//                         <table className="table table-hover table-bordered align-middle">
//                           <thead className="table-light">
//                             <tr>
//                               <th>#</th>
//                               <th>Call Number</th>
//                               <th>Location</th>
//                               <th>Status</th>
//                               <th className="text-center">Action</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {bookCopies.map((copy, index) => (
//                               <tr key={copy.id}>
//                                 <td style={{ width: '60px' }}>
//                                   {(copiesPage - 1) * 10 + index + 1}
//                                 </td>
//                                 <td>
//                                   {copy.itemcallnumber ? (
//                                     <span className="fw-semibold">{copy.itemcallnumber}</span>
//                                   ) : (
//                                     <span className="text-muted fst-italic">Not assigned</span>
//                                   )}
//                                 </td>
//                                 <td>
//                                   {copy.rack_location ? (
//                                     <span>📍 {copy.rack_location}</span>
//                                   ) : (
//                                     <span className="text-muted fst-italic">Not specified</span>
//                                   )}
//                                 </td>
//                                 <td style={{ width: '120px' }}>
//                                   <Badge
//                                     bg={copy.status === 'AVAILABLE' ? 'success' : 'secondary'}
//                                     className="px-3 py-2 w-100"
//                                   >
//                                     {copy.status}
//                                   </Badge>
//                                 </td>
//                                 <td style={{ width: '120px' }} className="text-center">
//                                   <Button
//                                     variant={copy.status === 'AVAILABLE' ? 'primary' : 'outline-secondary'}
//                                     size="sm"
//                                     disabled={copy.status !== 'AVAILABLE'}
//                                     onClick={() => requestSpecificCopy(copy.id)}
//                                     className="px-3 w-100"
//                                   >
//                                     {copy.status === 'AVAILABLE' ? 'Request' : 'Not Available'}
//                                   </Button>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>

//                       {/* Pagination for Book Copies */}
//                       {copiesTotalPages > 1 && (
//                         <div className="d-flex justify-content-center mt-4">
//                           <nav>
//                             <ul className="pagination">
//                               <li className={`page-item ${copiesPage === 1 ? 'disabled' : ''}`}>
//                                 <button
//                                   className="page-link"
//                                   onClick={() => handleCopiesPageChange(copiesPage - 1)}
//                                 >
//                                   Previous
//                                 </button>
//                               </li>
//                               {[...Array(copiesTotalPages)].map((_, i) => (
//                                 <li key={i + 1} className={`page-item ${copiesPage === i + 1 ? 'active' : ''}`}>
//                                   <button
//                                     className="page-link"
//                                     onClick={() => handleCopiesPageChange(i + 1)}
//                                   >
//                                     {i + 1}
//                                   </button>
//                                 </li>
//                               ))}
//                               <li className={`page-item ${copiesPage === copiesTotalPages ? 'disabled' : ''}`}>
//                                 <button
//                                   className="page-link"
//                                   onClick={() => handleCopiesPageChange(copiesPage + 1)}
//                                 >
//                                   Next
//                                 </button>
//                               </li>
//                             </ul>
//                           </nav>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </Card.Body>
//               </Card>
//             )}

//             {/* Pagination for Books */}
//             {totalPages > 1 && (
//               <div className="d-flex justify-content-center mt-4">
//                 <nav>
//                   <ul className="pagination">
//                     <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => loadBooks(page - 1)}
//                       >
//                         Previous
//                       </button>
//                     </li>
//                     {[...Array(totalPages)].map((_, i) => (
//                       <li key={i + 1} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
//                         <button
//                           className="page-link"
//                           onClick={() => loadBooks(i + 1)}
//                         >
//                           {i + 1}
//                         </button>
//                       </li>
//                     ))}
//                     <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => loadBooks(page + 1)}
//                       >
//                         Next
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             )}
//           </>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default OPAC;
// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Badge } from 'react-bootstrap';
// import './OPAC.css';

// const OPAC = () => {
//   const [card_number, setcard_number] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [member, setMember] = useState(null);
//   const [books, setBooks] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [myRequests, setMyRequests] = useState([]);
//   const [showRequests, setShowRequests] = useState(false);
//   const [showBookCopies, setShowBookCopies] = useState(false);
//   const [selectedBook, setSelectedBook] = useState(null);
//   const [bookCopies, setBookCopies] = useState([]);
//   const [copiesPage, setCopiesPage] = useState(1);
//   const [copiesTotalPages, setCopiesTotalPages] = useState(1);
//   const [totalCopies, setTotalCopies] = useState(0);

//   useEffect(() => {
//     if (card_number.length > 0) {
//       verifyMember();
//     } else {
//       setMember(null);
//       setBooks([]);
//     }
//   }, [card_number]);

//   useEffect(() => {
//     if (member) {
//       loadCategories();
//       loadBooks();
//     }
//   }, [member]);

//   const verifyMember = async () => {
//     if (!card_number) return;

//     setLoading(true);
//     setError('');

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/verify-member', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({ card_number })
//       });

//       const data = await response.json();

//       if (data.success) {
//         setMember(data.member);
//         setSuccess('Member verified successfully!');
//         setTimeout(() => setSuccess(''), 3000);
//       } else {
//         setError(data.message || 'Member verification failed');
//         setMember(null);
//       }
//     } catch (err) {
//       console.error('Error:', err);
//       setError('Failed to verify member. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadCategories = async () => {
//     try {
//       const response = await fetch('http://localhost:3003/api/opac/categories');
//       const data = await response.json();
//       if (data.success) {
//         setCategories(data.data);
//       }
//     } catch (err) {
//       console.error('Failed to load categories:', err);
//     }
//   };

//   const loadBooks = async (pageNum = 1) => {
//     try {
//       setLoading(true);
//       const params = new URLSearchParams({
//         page: pageNum,
//         limit: 12
//       });

//       if (searchTerm) params.append('search', searchTerm);
//       if (selectedCategory) params.append('category', selectedCategory);
//       if (member?.branchId) params.append('branchId', member.branchId);

//       const response = await fetch(`http://localhost:3003/api/opac/books?${params}`);
//       const data = await response.json();

//       if (data.success) {
//         setBooks(data.data);
//         setTotalPages(data.pagination.totalPages);
//         setPage(pageNum);
//       }
//     } catch (err) {
//       setError('Failed to load books');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     loadBooks(1);
//   };

//   const handleRequestBook = async (book) => {
//     if (!member) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     setSelectedBook(book);
//     setShowBookCopies(true);
//     setCopiesPage(1);
//     loadBookCopies(book.id);
//   };

//   const loadBookCopies = async (bookId, pageNum = 1) => {
//     try {
//       setLoading(true);
//       const response = await fetch(`http://localhost:3003/api/opac/book-copies?bookId=${bookId}&page=${pageNum}&limit=10`);
//       const data = await response.json();

//       if (data.success) {
//         setBookCopies(data.data);
//         setCopiesTotalPages(data.pagination.totalPages);
//         setTotalCopies(data.pagination.totalItems);
//         setCopiesPage(pageNum);
//       } else {
//         setError('Failed to load book copies');
//       }
//     } catch (err) {
//       setError('Failed to load book copies');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCopiesPageChange = (newPage) => {
//     loadBookCopies(selectedBook.id, newPage);
//   };

//   const requestSpecificCopy = async (copyId) => {
//     if (!member || !selectedBook) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/request-copy', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           copyId: copyId,
//           bookId: selectedBook.id,
//           memberId: member.id
//         })
//       });

//       const data = await response.json();
//       if (data.success) {
//         setSuccess('Book copy requested successfully!');
//         setTimeout(() => setSuccess(''), 3000);
//         setShowBookCopies(false);
//         loadBooks(page);
//         if (showRequests) {
//           loadMyRequests();
//         }
//       } else {
//         setError(data.message);
//         setTimeout(() => setError(''), 3000);
//       }
//     } catch (err) {
//       setError('Failed to request book copy');
//       setTimeout(() => setError(''), 3000);
//     }
//   };

//   const loadMyRequests = async () => {
//     if (!member) {
//       setError('Please verify your membership first');
//       setTimeout(() => setError(''), 3000);
//       return;
//     }

//     try {
//       const response = await fetch('http://localhost:3003/api/opac/my-requests');
//       const data = await response.json();
//       if (data.success) {
//         setMyRequests(data.data);
//       } else {
//         setError('Failed to load requests');
//       }
//     } catch (err) {
//       setError('Failed to load requests');
//     }
//   };

//   useEffect(() => {
//     if (showRequests && member) {
//       loadMyRequests();
//     }
//   }, [showRequests, member]);

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       'PENDING': { variant: 'warning', text: 'Pending' },
//       'APPROVED': { variant: 'success', text: 'Approved' },
//       'REJECTED': { variant: 'danger', text: 'Rejected' },
//       'ISSUED': { variant: 'primary', text: 'Issued' },
//       'RETURNED': { variant: 'secondary', text: 'Returned' }
//     };

//     const config = statusConfig[status] || { variant: 'secondary', text: status };
//     return <Badge bg={config.variant}>{config.text}</Badge>;
//   };

//   return (
//     <div className="opac-container">
//       <Container className="py-4">
//         {/* Single Row with Text Field */}
//         <Row className="justify-content-center mb-4">
//           <Col md={8}>
//             <Card className="shadow-sm border-0">
//               <Card.Body className="p-3">
//                 <Row className="align-items-center">
//                   <Col xs={12}>
//                     <div className="d-flex align-items-center gap-2">
//                       <span className="fs-4">📚</span>
//                       <Form.Control
//                         type="text"
//                         placeholder="Enter Library Membership ID"
//                         value={card_number}
//                         onChange={(e) => setcard_number(e.target.value)}
//                         size="lg"
//                         className="border-secondary"
//                         style={{ flex: 1 }}
//                       />
//                       {loading && <Spinner animation="border" size="sm" variant="secondary" />}
//                     </div>
//                   </Col>
//                 </Row>
//                 {member && (
//                   <div className="mt-2 small text-muted">
//                     Logged in as: {member.firstName} {member.lastName} ({member.planName})
//                   </div>
//                 )}
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>

//         {/* Alerts */}
//         {error && (
//           <Row className="justify-content-center mb-3">
//             <Col md={8}>
//               <Alert variant="danger" onClose={() => setError('')} dismissible>
//                 {error}
//               </Alert>
//             </Col>
//           </Row>
//         )}

//         {success && (
//           <Row className="justify-content-center mb-3">
//             <Col md={8}>
//               <Alert variant="success" onClose={() => setSuccess('')} dismissible>
//                 {success}
//               </Alert>
//             </Col>
//           </Row>
//         )}

//         {/* Main Content - Only show if member is verified */}
//         {member && (
//           <>
//             {/* Search and Filters */}
//             <Card className="mb-4 shadow-sm">
//               <Card.Body>
//                 <Form onSubmit={handleSearch}>
//                   <Row>
//                     <Col md={5}>
//                       <Form.Control
//                         type="text"
//                         placeholder="Search books by title, author, or ISBN..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                       />
//                     </Col>
//                     <Col md={4}>
//                       <Form.Select
//                         value={selectedCategory}
//                         onChange={(e) => setSelectedCategory(e.target.value)}
//                       >
//                         <option value="">All Categories</option>
//                         {categories.map(cat => (
//                           <option key={cat.id} value={cat.id}>
//                             {cat.name} ({cat.book_count})
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={2}>
//                       <Button type="submit" variant="secondary" className="w-100">
//                         🔍 Search
//                       </Button>
//                     </Col>
//                     <Col md={1}>
//                       <Button
//                         variant="outline-secondary"
//                         className="w-100"
//                         onClick={() => setShowRequests(!showRequests)}
//                         title="My Requests"
//                       >
//                         📋 {myRequests.length > 0 && `(${myRequests.length})`}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </Card.Body>
//             </Card>

//             {/* My Requests Panel */}
//             {showRequests && (
//               <Card className="mb-4 shadow">
//                 <Card.Header className="d-flex justify-content-between align-items-center bg-light">
//                   <h5 className="mb-0">My Book Requests</h5>
//                   <Button variant="outline-secondary" size="sm" onClick={() => setShowRequests(false)}>
//                     ✕
//                   </Button>
//                 </Card.Header>
//                 <Card.Body>
//                   {myRequests.length === 0 ? (
//                     <p className="text-center text-muted">No requests found</p>
//                   ) : (
//                     <div className="requests-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
//                       {myRequests.map(request => (
//                         <div key={request.id} className="request-item p-3 border-bottom">
//                           <div className="d-flex justify-content-between align-items-center">
//                             <div>
//                               <h6 className="mb-1">{request.title}</h6>
//                               <small className="text-muted">by {request.author_name}</small>
//                             </div>
//                             <div className="text-end">
//                               {getStatusBadge(request.status)}
//                               <div className="mt-1">
//                                 <small className="text-muted">
//                                   {new Date(request.requested_date).toLocaleDateString()}
//                                 </small>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             )}

//             {/* Books Grid */}
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h4>Available Books</h4>
//               <div className="text-muted">
//                 Showing {books.length} books
//               </div>
//             </div>

//             <Row>
//               {books.map(book => (
//                 <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
//                   <Card className="h-100 book-card shadow-sm">
//                     <div className="book-cover-placeholder">
//                       {book.image_url ? (
//                         <Card.Img
//                           variant="top"
//                           src={book.image_url}
//                           alt={book.title}
//                           className="book-cover"
//                         />
//                       ) : (
//                         <div className="book-cover-placeholder-content">
//                           <div className="book-icon">📚</div>
//                           <div className="mt-2">No Cover</div>
//                         </div>
//                       )}
//                     </div>
//                     <Card.Body className="d-flex flex-column">
//                       <Card.Title className="book-title mb-2">
//                         {book.title}
//                       </Card.Title>
//                       <Card.Text className="text-muted small mb-2">
//                         by {book.author_name || 'Unknown Author'}
//                       </Card.Text>
//                       <div className="mt-auto">
//                         <div className="d-flex justify-content-between align-items-center mb-2">
//                           <Badge bg="secondary">{book.category_name}</Badge>
//                           <div className="text-success">
//                             <span className="me-1">✓</span>
//                             {book.available_copies} available
//                           </div>
//                         </div>
//                         <Button
//                           variant="secondary"
//                           className="w-100"
//                           onClick={() => handleRequestBook(book)}
//                           disabled={book.available_copies === 0}
//                         >
//                           {book.available_copies > 0 ? 'Request Book' : 'Not Available'}
//                         </Button>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               ))}
//             </Row>

//             {/* Book Copies Panel */}
//             {showBookCopies && selectedBook && (
//               <Card className="mb-4 shadow-lg">
//                 <Card.Header className="d-flex justify-content-between align-items-center bg-light">
//                   <h5 className="mb-0">{selectedBook.title}</h5>
//                   <div>
//                     <small className="me-3 text-muted">
//                       Total: {totalCopies} | Available: {bookCopies.filter(c => c.status === 'AVAILABLE').length}
//                     </small>
//                     <Button variant="outline-secondary" size="sm" onClick={() => setShowBookCopies(false)}>
//                       ✕ Close
//                     </Button>
//                   </div>
//                 </Card.Header>
//                 <Card.Body>
//                   {loading ? (
//                     <div className="text-center py-4">
//                       <Spinner animation="border" variant="secondary" />
//                       <p className="text-muted mt-2">Loading book copies...</p>
//                     </div>
//                   ) : bookCopies.length === 0 ? (
//                     <div className="text-center py-4">
//                       <div className="display-1 text-muted">📚</div>
//                       <p className="text-muted">No copies available for this book</p>
//                     </div>
//                   ) : (
//                     <>
//                       <div className="table-responsive">
//                         <table className="table table-hover table-bordered align-middle">
//                           <thead className="table-light">
//                             <tr>
//                               <th>#</th>
//                               <th>Call Number</th>
//                               <th>Location</th>
//                               <th>Status</th>
//                               <th className="text-center">Action</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {bookCopies.map((copy, index) => (
//                               <tr key={copy.id}>
//                                 <td style={{ width: '60px' }}>
//                                   {(copiesPage - 1) * 10 + index + 1}
//                                 </td>
//                                 <td>
//                                   {copy.itemcallnumber ? (
//                                     <span className="fw-semibold">{copy.itemcallnumber}</span>
//                                   ) : (
//                                     <span className="text-muted fst-italic">Not assigned</span>
//                                   )}
//                                 </td>
//                                 <td>
//                                   {copy.rack_location ? (
//                                     <span>📍 {copy.rack_location}</span>
//                                   ) : (
//                                     <span className="text-muted fst-italic">Not specified</span>
//                                   )}
//                                 </td>
//                                 <td style={{ width: '120px' }}>
//                                   <Badge
//                                     bg={copy.status === 'AVAILABLE' ? 'success' : 'secondary'}
//                                     className="px-3 py-2 w-100"
//                                   >
//                                     {copy.status}
//                                   </Badge>
//                                 </td>
//                                 <td style={{ width: '120px' }} className="text-center">
//                                   <Button
//                                     variant={copy.status === 'AVAILABLE' ? 'secondary' : 'outline-secondary'}
//                                     size="sm"
//                                     disabled={copy.status !== 'AVAILABLE'}
//                                     onClick={() => requestSpecificCopy(copy.id)}
//                                     className="px-3 w-100"
//                                   >
//                                     {copy.status === 'AVAILABLE' ? 'Request' : 'Not Available'}
//                                   </Button>
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>

//                       {/* Pagination for Book Copies */}
//                       {copiesTotalPages > 1 && (
//                         <div className="d-flex justify-content-center mt-4">
//                           <nav>
//                             <ul className="pagination">
//                               <li className={`page-item ${copiesPage === 1 ? 'disabled' : ''}`}>
//                                 <button
//                                   className="page-link"
//                                   onClick={() => handleCopiesPageChange(copiesPage - 1)}
//                                 >
//                                   Previous
//                                 </button>
//                               </li>
//                               {[...Array(copiesTotalPages)].map((_, i) => (
//                                 <li key={i + 1} className={`page-item ${copiesPage === i + 1 ? 'active' : ''}`}>
//                                   <button
//                                     className="page-link"
//                                     onClick={() => handleCopiesPageChange(i + 1)}
//                                   >
//                                     {i + 1}
//                                   </button>
//                                 </li>
//                               ))}
//                               <li className={`page-item ${copiesPage === copiesTotalPages ? 'disabled' : ''}`}>
//                                 <button
//                                   className="page-link"
//                                   onClick={() => handleCopiesPageChange(copiesPage + 1)}
//                                 >
//                                   Next
//                                 </button>
//                               </li>
//                             </ul>
//                           </nav>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </Card.Body>
//               </Card>
//             )}

//             {/* Pagination for Books */}
//             {totalPages > 1 && (
//               <div className="d-flex justify-content-center mt-4">
//                 <nav>
//                   <ul className="pagination">
//                     <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => loadBooks(page - 1)}
//                       >
//                         Previous
//                       </button>
//                     </li>
//                     {[...Array(totalPages)].map((_, i) => (
//                       <li key={i + 1} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
//                         <button
//                           className="page-link"
//                           onClick={() => loadBooks(i + 1)}
//                         >
//                           {i + 1}
//                         </button>
//                       </li>
//                     ))}
//                     <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => loadBooks(page + 1)}
//                       >
//                         Next
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             )}
//           </>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default OPAC;
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Badge } from 'react-bootstrap';
import './OPAC.css';

const OPAC = () => {
  const [card_number, setcard_number] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [member, setMember] = useState(null);
  const [books, setBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [myRequests, setMyRequests] = useState([]);
  const [showRequests, setShowRequests] = useState(false);
  const [showBookCopies, setShowBookCopies] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [bookCopies, setBookCopies] = useState([]);
  const [copiesPage, setCopiesPage] = useState(1);
  const [copiesTotalPages, setCopiesTotalPages] = useState(1);
  const [totalCopies, setTotalCopies] = useState(0);

  // Auto verify when card number changes
  useEffect(() => {
    if (card_number.length > 0) {
      verifyMember();
    } else {
      setMember(null);
      setBooks([]);
    }
  }, [card_number]);

  useEffect(() => {
    if (member) {
      loadCategories();
      loadBooks();
    }
  }, [member]);

  const verifyMember = async () => {
    if (!card_number) return;

    setLoading(true);
    setError('');

    try {
      const response = await fetch('http://localhost:3003/api/opac/verify-member', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ card_number })
      });

      const data = await response.json();

      if (data.success) {
        setMember(data.member);
        setSuccess('Member verified successfully!');
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(data.message || 'Member verification failed');
        setMember(null);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to verify member. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      const response = await fetch('http://localhost:3003/api/opac/categories');
      const data = await response.json();
      if (data.success) {
        setCategories(data.data);
      }
    } catch (err) {
      console.error('Failed to load categories:', err);
    }
  };

  const loadBooks = async (pageNum = 1) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: pageNum,
        limit: 12
      });

      if (searchTerm) params.append('search', searchTerm);
      if (selectedCategory) params.append('category', selectedCategory);
      if (member?.branchId) params.append('branchId', member.branchId);

      const response = await fetch(`http://localhost:3003/api/opac/books?${params}`);
      const data = await response.json();

      if (data.success) {
        setBooks(data.data);
        setTotalPages(data.pagination.totalPages);
        setPage(pageNum);
      }
    } catch (err) {
      setError('Failed to load books');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    loadBooks(1);
  };

  const handleRequestBook = async (book) => {
    if (!member) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    setSelectedBook(book);
    setShowBookCopies(true);
    setCopiesPage(1);
    loadBookCopies(book.id);
  };

  const loadBookCopies = async (bookId, pageNum = 1) => {
    try {
      setLoading(true);
      const response = await fetch(`http://localhost:3003/api/opac/book-copies?bookId=${bookId}&page=${pageNum}&limit=10`);
      const data = await response.json();

      if (data.success) {
        setBookCopies(data.data);
        setCopiesTotalPages(data.pagination.totalPages);
        setTotalCopies(data.pagination.totalItems);
        setCopiesPage(pageNum);
      } else {
        setError('Failed to load book copies');
      }
    } catch (err) {
      setError('Failed to load book copies');
    } finally {
      setLoading(false);
    }
  };

  const handleCopiesPageChange = (newPage) => {
    loadBookCopies(selectedBook.id, newPage);
  };

  const requestSpecificCopy = async (copyId) => {
    if (!member || !selectedBook) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      const response = await fetch('http://localhost:3003/api/opac/request-copy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          copyId: copyId,
          bookId: selectedBook.id,
          memberId: member.id
        })
      });

      const data = await response.json();
      if (data.success) {
        setSuccess('Book copy requested successfully!');
        setTimeout(() => setSuccess(''), 3000);
        setShowBookCopies(false);
        loadBooks(page);
        if (showRequests) {
          loadMyRequests();
        }
      } else {
        setError(data.message);
        setTimeout(() => setError(''), 3000);
      }
    } catch (err) {
      setError('Failed to request book copy');
      setTimeout(() => setError(''), 3000);
    }
  };

  const loadMyRequests = async () => {
    if (!member) {
      setError('Please verify your membership first');
      setTimeout(() => setError(''), 3000);
      return;
    }

    try {
      const response = await fetch('http://localhost:3003/api/opac/my-requests');
      const data = await response.json();
      if (data.success) {
        setMyRequests(data.data);
      } else {
        setError('Failed to load requests');
      }
    } catch (err) {
      setError('Failed to load requests');
    }
  };

  useEffect(() => {
    if (showRequests && member) {
      loadMyRequests();
    }
  }, [showRequests, member]);

  const getStatusBadge = (status) => {
    const statusConfig = {
      'PENDING': { variant: 'warning', text: 'Pending' },
      'APPROVED': { variant: 'success', text: 'Approved' },
      'REJECTED': { variant: 'danger', text: 'Rejected' },
      'ISSUED': { variant: 'primary', text: 'Issued' },
      'RETURNED': { variant: 'secondary', text: 'Returned' }
    };

    const config = statusConfig[status] || { variant: 'secondary', text: status };
    return <Badge bg={config.variant}>{config.text}</Badge>;
  };

  return (
    <div className="opac-container">
      <Container className="py-4">
        {/* Single Row with Text Field */}
        <Row className="justify-content-center mb-4">
          <Col md={8}>
            <Card className="shadow-sm border-0">
              <Card.Body className="p-3">
                <Row className="align-items-center">
                  <Col xs={12}>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fs-4">📚</span>
                      <Form.Control
                        type="text"
                        placeholder="Enter Library Membership ID"
                        value={card_number}
                        onChange={(e) => setcard_number(e.target.value)}
                        size="lg"
                        className="border-secondary"
                        style={{ flex: 1 }}
                      />
                      {loading && <Spinner animation="border" size="sm" variant="secondary" />}
                    </div>
                  </Col>
                </Row>
                {member && (
                  <div className="mt-2 small text-muted">
                    Logged in as: {member.firstName} {member.lastName}  | ({member.planName})  | {member.allowedBooks} books allowed
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Alerts */}
        {error && (
          <Row className="justify-content-center mb-3">
            <Col md={8}>
              <Alert variant="danger" onClose={() => setError('')} dismissible>
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {success && (
          <Row className="justify-content-center mb-3">
            <Col md={8}>
              <Alert variant="success" onClose={() => setSuccess('')} dismissible>
                {success}
              </Alert>
            </Col>
          </Row>
        )}

        {/* Main Content - Only show if member is verified */}
        {member && (
          <>
            {/* Search and Filters with Background Image */}
            <div className="search-container mb-4">
              <div className="search-content">
                <Card className="bg-transparent border-0">
                  <Card.Body>
                    <Form onSubmit={handleSearch}>
                      <Row>
                        <Col md={5}>
                          <Form.Control
                            type="text"
                            placeholder="Search books by title, author, or ISBN..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </Col>
                        <Col md={4}>
                          <Form.Select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                          >
                            <option value="">All Categories</option>
                            {categories.map(cat => (
                              <option key={cat.id} value={cat.id}>
                                {cat.name} ({cat.book_count})
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col md={2}>
                          <Button type="submit" variant="secondary" className="w-100">
                            🔍 Search
                          </Button>
                        </Col>
                        <Col md={1}>
                          <Button
                            variant="outline-light"
                            className="w-100"
                            onClick={() => setShowRequests(!showRequests)}
                            title="My Requests"
                          >
                            📋 {myRequests.length > 0 && `(${myRequests.length})`}
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>

            {/* My Requests Panel */}
            {showRequests && (
              <Card className="mb-4 shadow">
                <Card.Header className="d-flex justify-content-between align-items-center bg-light">
                  <h5 className="mb-0">My Book Requests</h5>
                  <Button variant="outline-secondary" size="sm" onClick={() => setShowRequests(false)}>
                    ✕
                  </Button>
                </Card.Header>
                <Card.Body>
                  {myRequests.length === 0 ? (
                    <p className="text-center text-muted">No requests found</p>
                  ) : (
                    <div className="requests-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {myRequests.map(request => (
                        <div key={request.id} className="request-item p-3 border-bottom">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="mb-1">{request.title}</h6>
                              <small className="text-muted">by {request.author_name}</small>
                            </div>
                            <div className="text-end">
                              {getStatusBadge(request.status)}
                              <div className="mt-1">
                                <small className="text-muted">
                                  {new Date(request.requested_date).toLocaleDateString()}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}

            {/* Books Grid with Pattern Background */}
            <div className="books-grid">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-white">Available Books</h4>
                <div className="text-white">
                  Showing {books.length} books
                </div>
              </div>

              <Row>
                {books.map(book => (
                  <Col key={book.id} md={6} lg={4} xl={3} className="mb-4">
                    <Card className="h-100 book-card shadow-sm">
                      {/* <div className="book-cover-placeholder">
                        {book.image_url ? (
                          <Card.Img
                            variant="top"
                            src={book.image_url}
                            alt={book.title}
                            className="book-cover"
                          />
                        ) : (
                          <div className="book-cover-placeholder-content">
                            <div className="book-icon">📚</div>
                            <div className="mt-2">No Cover</div>
                          </div>
                        )}
                      </div> */}
                      <Card.Body className="d-flex flex-column">
                        <Card.Title className="book-title mb-2">
                          {book.title}
                          {book.isbn && <span className="ms-2 text-muted small">({book.isbn})</span>}
                        </Card.Title>
                        <Card.Text className="text-muted small mb-2">
                          by {book.author_name || 'Unknown Author'}
                        </Card.Text>
                        <div className="mt-auto">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <Badge bg="secondary">{book.category_name}</Badge>
                            <div className="text-success">
                              <span className="me-1">✓</span>
                              {book.available_copies} available
                            </div>
                          </div>
                          <Button
                            variant="secondary"
                            className="w-100"
                            onClick={() => handleRequestBook(book)}
                            disabled={book.available_copies === 0}
                          >
                            {book.available_copies > 0 ? 'Request Book' : 'Not Available'}
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>

            {/* Book Copies Panel */}
            {showBookCopies && selectedBook && (
              <Card className="mb-4 shadow-lg mt-4">
                <Card.Header className="d-flex justify-content-between align-items-center bg-light">
                  <h5 className="mb-0">{selectedBook.title}</h5>
                  <div>
                    <small className="me-3 text-muted">
                      Total: {totalCopies} | Available: {bookCopies.filter(c => c.status === 'AVAILABLE').length}
                    </small>
                    <Button variant="outline-secondary" size="sm" onClick={() => setShowBookCopies(false)}>
                      ✕ Close
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body>
                  {loading ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="secondary" />
                      <p className="text-muted mt-2">Loading book copies...</p>
                    </div>
                  ) : bookCopies.length === 0 ? (
                    <div className="text-center py-4">
                      <div className="display-1 text-muted">📚</div>
                      <p className="text-muted">No copies available for this book</p>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover table-bordered align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Call Number</th>
                              <th>Location</th>
                              <th>Status</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookCopies.map((copy, index) => (
                              <tr key={copy.id}>
                                <td style={{ width: '60px' }}>
                                  {(copiesPage - 1) * 10 + index + 1}
                                </td>
                                <td>
                                  {copy.itemcallnumber ? (
                                    <span className="fw-semibold">{copy.itemcallnumber}</span>
                                  ) : (
                                    <span className="text-muted fst-italic">Not assigned</span>
                                  )}
                                </td>
                                <td>
                                  {copy.rack_location ? (
                                    <span>📍 {copy.rack_location}</span>
                                  ) : (
                                    <span className="text-muted fst-italic">Not specified</span>
                                  )}
                                </td>
                                <td style={{ width: '120px' }}>
                                  <Badge
                                    bg={copy.status === 'AVAILABLE' ? 'success' : 'secondary'}
                                    className="px-3 py-2 w-100"
                                  >
                                    {copy.status}
                                  </Badge>
                                </td>
                                <td style={{ width: '120px' }} className="text-center">
                                  <Button
                                    variant={copy.status === 'AVAILABLE' ? 'secondary' : 'outline-secondary'}
                                    size="sm"
                                    disabled={copy.status !== 'AVAILABLE'}
                                    onClick={() => requestSpecificCopy(copy.id)}
                                    className="px-3 w-100"
                                  >
                                    {copy.status === 'AVAILABLE' ? 'Request' : 'Not Available'}
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination for Book Copies */}
                      {copiesTotalPages > 1 && (
                        <div className="d-flex justify-content-center mt-4">
                          <nav>
                            <ul className="pagination">
                              <li className={`page-item ${copiesPage === 1 ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => handleCopiesPageChange(copiesPage - 1)}
                                >
                                  Previous
                                </button>
                              </li>
                              {[...Array(copiesTotalPages)].map((_, i) => (
                                <li key={i + 1} className={`page-item ${copiesPage === i + 1 ? 'active' : ''}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => handleCopiesPageChange(i + 1)}
                                  >
                                    {i + 1}
                                  </button>
                                </li>
                              ))}
                              <li className={`page-item ${copiesPage === copiesTotalPages ? 'disabled' : ''}`}>
                                <button
                                  className="page-link"
                                  onClick={() => handleCopiesPageChange(copiesPage + 1)}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            )}

            {/* Pagination for Books */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => loadBooks(page - 1)}
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, i) => (
                      <li key={i + 1} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => loadBooks(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => loadBooks(page + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default OPAC;